import React from 'react';

import {
  faTimes as xOut
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import Modal from 'static/three-oh/src/components/Modal/Modal';

import styles from './styles.scss';

const propTypesStyledModal = {
  ...Modal.propTypes,
  body: PropTypes.object,
  footer: PropTypes.object,
  header: PropTypes.object,
  scrollBody: PropTypes.bool,
  title: PropTypes.string,
  additionalFooterStyles: PropTypes.string,
};

class StyledModal extends React.Component {
  render() {
    return (
      <Modal {...this.props}>
        <div
          className={styles.container}
          data-qa-selector="styled_modal"
        >
          {
            this.props.title &&
            <section className={styles.title}>
              <span data-qa-selector="modal_title">{this.props.title}</span>
              <button
                onClick={(event) => this.props.onClose(event)}
                className={styles.closeButton}
              >
                <FontAwesomeIcon icon={xOut} />
              </button>
            </section>
          }
          {this.props.header &&
            <section className={styles.header}>
              {this.props.header}
            </section>}

          {this.props.body &&
            <section className={`${styles.body} ${this.props.scrollBody ? styles.scrollBody : ''}`}>
              {this.props.body}
            </section>}

          {this.props.footer &&
            <section
              className={`${styles.footer} ${this.props.additionalFooterStyles}`}
            >
              {this.props.footer}
            </section>}

        </div>
      </Modal>
    );
  }
}

StyledModal.propTypes = propTypesStyledModal;
StyledModal.defaultProps = {
  scrollBody: false,
};

export default StyledModal;
